import React from 'react';
import Link from '../common/TrackedLink';
import SiteSearchImage from './SiteSearchImage';
import renderHTML from 'react-render-html';

const CategoriesSiteSearch = ({ category }) => {
	return (		
		<li className="results-list-item">
			<SiteSearchImage imageName={category.imageName} />
			<div>
				<h2>{ category.name }</h2>
				<p>{ renderHTML(category.description) }</p>
				<Link className="arrow-link" to={ `/${category.slug}` }>View more</Link>
			</div>
		</li>
	);
};

export default CategoriesSiteSearch;


// WEBPACK FOOTER //
// ./src/pages/sitesearch/CategoriesSiteSearch.js